export const LUXPLUS_PROMO_CARD_CAROUSEL_FLAG = 'loyalty:luxplusPromoCardCarousel';
export const LUXPLUS_PROMO_BANNER_CAROUSEL_FLAG = 'loyalty:luxplusPromoBannerCarousel';

export const PROMO_CODE_PROMOTION = 'promo_code';
export const CTA_PROMOTION = 'cta';
export const FLIGHT_VOUCHER_PROMOTION = 'flight_voucher';

export const LUXPLUS_PROMO_CARD_TYPES = [PROMO_CODE_PROMOTION, CTA_PROMOTION, FLIGHT_VOUCHER_PROMOTION] as const;

export const LUXPLUS_PROMO_BANNER_CTA_LINK_TYPES = ['link', 'sign-up'] as const;

export const LUXPLUS_PROMO_CARD_TYPE_LABELS: Record<(typeof LUXPLUS_PROMO_CARD_TYPES)[number], string> = {
  [PROMO_CODE_PROMOTION]: 'Promo code',
  [CTA_PROMOTION]: 'CTA',
  [FLIGHT_VOUCHER_PROMOTION]: 'Flight voucher',
};

export const LUXPLUS_PROMO_BANNER_CTA_LINK_TYPE_LABELS: Record<
  (typeof LUXPLUS_PROMO_BANNER_CTA_LINK_TYPES)[number],
  string
> = {
  link: 'Link',
  'sign-up': 'Sign up',
};
